import React from "react";
import { SlideShell } from "../../../shared/components/SlideShell";

const IMG = "https://images.pexels.com/photos/29422607/pexels-photo-29422607.jpeg";

export const Slide9 = ({ t, total, onActive }) => {
  return (
    <SlideShell index={8} total={total} onActive={onActive} label="Scaling">
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `url(${IMG})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          opacity: 0.7,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-tr from-black via-black/70 to-transparent" />

      <div className="relative z-10 w-full max-w-[90rem] px-6 md:px-12 mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-start">
          {/* Left Column (Existing) */}
          <div className="lg:col-start-2 lg:col-span-5 max-w-3xl">
            <div className="overline mb-6">{t.overline}</div>
            <h2 className="font-display font-medium text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tighter">
              {t.heading}
            </h2>
            <p className="mt-8 text-lg md:text-xl text-neutral-300 font-light leading-relaxed">
              {t.body}
            </p>

            <div className="mt-12 glass-strong rounded-2xl p-8">
              <div className="font-mono text-[10px] tracking-widest text-[var(--ph-accent)] mb-6">
                REPLICATION SEQUENCE
              </div>
              <div className="space-y-4">
                {t.sequence.map((s, i) => (
                  <div
                    key={i}
                    className="flex items-center gap-5"
                    data-testid={`s9-sequence-${i}`}
                  >
                    <span
                      className={`font-mono text-xs w-8 h-8 rounded-full flex items-center justify-center ${
                        i === 0
                          ? "bg-[var(--ph-accent)] text-black"
                          : "border border-white/15 text-neutral-500"
                      }`}
                    >
                      {i + 1}
                    </span>
                    <span className="flex-1 h-[1px] bg-white/10" />
                    <span
                      className={`font-display text-lg md:text-xl ${
                        i === 0 ? "text-white" : "text-neutral-400"
                      }`}
                    >
                      {s}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right Column (New) */}
          <div className="lg:col-span-6 mt-12 lg:mt-[3.25rem]">
            <h3 className="font-display font-medium text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tighter">
              {t.competingTitle}
            </h3>
            <div>
              <p className="mt-8 text-lg md:text-xl text-neutral-300 font-light leading-relaxed">
                {t.competingText}
              </p>
              
              <div className="mt-12 glass-strong rounded-2xl p-8">
                <div className="font-mono text-[10px] tracking-widest text-transparent mb-6 select-none">
                  SPACER
                </div>
                <div className="space-y-4">
                  {t.competingBullets.map((b, i) => (
                    <div key={i} className="flex items-center gap-5" data-testid={`s9-competing-${i}`}>
                      <span className="font-mono text-xs w-8 h-8 shrink-0 rounded-full flex items-center justify-center border border-white/15 text-red-400/80">
                        ✕
                      </span>
                      <span className="w-8 md:w-16 shrink-0 h-[1px] bg-white/10" />
                      <span className="font-display text-lg md:text-xl text-neutral-400">
                        {b}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SlideShell>
  );
};


